const styles = (props) => ({
  appBar: { top: 0, display: "flex" },
  toolbar: {
    width: "100%",
    height: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  logo: {
    width: "150px",
    height: "auto",
    marginTop: " 7px",
  },
  imgLogo: { width: "200px", height: "auto" },
  IconButtonLogo: {
    padding: 0,
    borderRadius: 0,
    width: "220px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transform: "translateX(-20px)",
  },
  main: {
    flexGrow: 1,
    p: 2,
    borderTopLeftRadius: 8,
  },
  toolbarNavigate: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
  },
  tab: {
    minWidth: "60px",
    height: "100%",
    maxWidth: "200px",
    justifyContent: "start",
    color: props.palette.white.main,
    opacity: 0.9,
    fontSize: "0.875 rem",
    "&:hover": {
      backgroundColor: props.palette.background.hover,
    },
  },
  containerFilter: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
});

export default styles;
